export default {"src":"/_next/static/media/Waveform-blue.2047bf82.svg","height":1600,"width":1600};